import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from '../config/axios';
import { Formik } from 'formik';
import { Box, Typography, Button, Alert } from '@mui/material';
import TextFieldPassword from '../components/TextFieldPassword';

const ResetPassword = () => {
    const { token } = useParams();
    const [message, setMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);

    return (
        <Box sx={{ maxWidth: '450px' }}>
            <Typography
                variant="h3"
                sx={{
                    fontWeight: 600,
                    color: 'text.primary',
                    mb: 2,
                    fontSize: { xs: '1.75rem', sm: '2.25rem' },
                }}
            >
                Reset Password
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    color: 'text.secondary',
                    mb: 5,
                    fontSize: '1rem',
                    lineHeight: 1.6,
                }}
            >
                Enter your new password below. Make sure it's secure and memorable.
            </Typography>

            <Formik
                initialValues={{
                    password: "",
                    confirm: ""
                }}
                onSubmit={async (values) => {
                    if (values.password !== values.confirm) {
                        setMessage('Passwords do not match');
                        setIsSuccess(false);
                        return;
                    }

                    try {
                        const response = await axios.put(`/auth/reset-password/${token}`, {
                            password: values.password
                        });
                        console.log(response);
                        setMessage('Password has been successfully reset. You can now sign in with your new password.');
                        setIsSuccess(true);
                    } catch (error) {
                        setMessage('Error resetting password. The link may have expired. Please try again.');
                        setIsSuccess(false);
                    }
                }}
            >
                {({ values, handleChange, handleSubmit }) => (
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <Box sx={{ mb: 4 }}>
                            <Typography
                                variant="body2"
                                sx={{ mb: 1, fontWeight: 500, color: 'text.primary' }}
                            >
                                New Password
                            </Typography>
                            <TextFieldPassword
                                formValue="password"
                                label=""
                                placeholder="Enter new password"
                                value={values.password}
                                onChange={handleChange('password')}
                                variant="outlined"
                            />
                        </Box>

                        <Box sx={{ mb: 4 }}>
                            <Typography
                                variant="body2"
                                sx={{ mb: 1, fontWeight: 500, color: 'text.primary' }}
                            >
                                Confirm New Password
                            </Typography>
                            <TextFieldPassword
                                formValue="confirm"
                                label=""
                                placeholder="Confirm new password"
                                value={values.confirm}
                                onChange={handleChange('confirm')}
                                error={values.confirm !== values.password && values.confirm.length > 0}
                                helperText={values.confirm !== values.password && values.confirm.length > 0 ? 'Passwords do not match' : ''}
                                variant="outlined"
                            />
                        </Box>

                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                            size="large"
                            disabled={!values.password || !values.confirm || values.password !== values.confirm}
                            sx={{
                                py: 1.75,
                                borderRadius: 2,
                                textTransform: 'none',
                                fontSize: '1.1rem',
                                fontWeight: 600,
                            }}
                        >
                            Reset Password
                        </Button>
                    </form>
                )}
            </Formik>

            {message && (
                <Alert severity={isSuccess ? "success" : "error"} sx={{ mt: 4, fontSize: '0.95rem' }}>
                    {message}
                </Alert>
            )}
        </Box>
    );
};

export default ResetPassword;
